import script from "./UserApprovalList.vue?vue&type=script&setup=true&lang=js"
export * from "./UserApprovalList.vue?vue&type=script&setup=true&lang=js"

import "./UserApprovalList.vue?vue&type=style&index=0&id=2e6936f8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2e6936f8"]])

export default __exports__